<template>
  <v-select
    v-model="select"
    :items="resItems"
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    :prepend-icon="prependIcon"
    :hint="hint"
    :disabled="curentDisabled"
    @click:append="() => this.select = []"
    :append-icon="'mdi-close'"
    :allow-overflow="false"
    return-object
    :readonly="readonly"
  />
</template>

<script>
export default {
  props: {
    label: String,
    getRequest: {
      type: Object,
      default: null,
    },
    paramsRequest: {
      type: Object,
      default: null,
    },
    selectedItem: null,
    prependIcon: String,
    itemText: String,
    itemValue: String,
    noDataText: String,
    itemsRoot: Array,
    selectAlone: {
      type: Boolean,
      default: true,
    },
    filtered: {
      type: Boolean,
      default: false,
    },
    notMultiple: {
      type: Boolean,
      default: false,
    },
    disabled:{
      type: Number,
      default: 0,
    },
    displayCount: {
      type: Number,
      default: 1
    }
  },
  data (){
    return {
      items: [],
      select: [],
      curentDisabled: false,
      readonly: false,
      hint: '',
      flagOut: true,
      flagIn: true,
    };
  },
  methods:{
    update(){
      this.getRequest.get(this.paramsRequest)
        .then(response => response.data)
        .then(json => {
          this.items = json;
          this.$emit('items', this.items);
        }
        )
        .catch(error => {
          console.error(error);
        });
    },
    checkedItemRoot(){
      if (!this.itemsRoot || this.itemsRoot.length < 1){
        this.readonly = true;
        this.hint = this.noDataText;
      }
      else {
        this.readonly = false;
        this.hint = '';
      }
    },
    checkDisabled(items){
      if(this.disabled !== null && this.disabled !== undefined && this.disabled === 1 || this.disabled === 2  && this.selectAlone && (items === null || items === undefined || items.length === 1))
        this.curentDisabled = true;
      else
        this.curentDisabled = false;
    },
  },
  watch:{
    items(){
      if (this.items !== null && this.items.length === 1 && this.selectAlone)
        this.select = this.items[0];
    },
    selectedItem(){
      if (this.flagOut){
        if (this.items !== null && this.items.length === 1 && this.selectAlone && (this.selectedItem == null || this.selectedItem.length == 0))
        {
          this.select = this.items[0];
          this.$emit('changed', this.select);
        }
        else
        {
          this.select = this.selectedItem;
          this.flagIn = false;
        }
      }
      else
        this.flagOut = true;
    },
    select(){
      if(this.flagIn){
        this.flagOut = false;
        this.$emit('changed', this.select);
      }
      else
        this.flagIn = true;
    },
  },
  computed:{
    resItems(){
      if(this.filtered){
        this.checkedItemRoot();
        this.checkDisabled(this.itemsRoot);

        return this.itemsRoot;
      }

      this.checkDisabled(this.items);

      return this.items;
    },
  },
  async mounted() {
    if (!this.filtered)
      this.update();
  },
};
</script>

<style>
  .v-select__selections {
    flex-wrap: nowrap;
  }
</style>